import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faEye,
  faPlayCircle,
} from '@fortawesome/free-solid-svg-icons';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import './SideMenuItem.css';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { markLessonAsWatched } from '../../../redux/actions/contentPayer';
import { useSelector } from 'react-redux';
import { addUserActivity } from '../../../redux/actions/profileDetails';
import { userActivity } from '../../../common/constants';
import { useEffect } from 'react';
import { IKImage } from 'imagekitio-react';
import TaskMskill from '../../MSkillListingPage/TaskMskill';
import { SET_LAST_MSKILL_DURATION } from '../../../redux/actions/types';


export default function SideMenuItem({
  sidebarRef,
  quizRef,
  currentMskill,
  content,
  active,
  setTilebarItem,
  setWatchedLessons,
  watchedLessons,
  isTask,
  task,
  handleTaskChange,
  
}) {
  const dispatch = useDispatch();
  const userId = useSelector((store) => store?.profileDetails?.id);
  const user_token = useSelector((store) => store?.authentication?.user_token);
  const navigate = useNavigate();
  const { course_slug, mskill_slug, skill_slug, contentId } = useParams();

  console.log(content , 'content')

  useEffect(() => {
    if (active) {
      // dispatch({type : SET_LAST_MSKILL_DURATION , payload : mskill?.['mskill_duration']})
    
      console.log('duration' , currentMskill)
      sidebarRef?.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      });
    }
  }, [content]);

  function isMarkedAsComplete(lessons, content) {
    const index = lessons.findIndex(
      (item) => item.lesson_id === content.id && item.completed === true
    );
    const otherIndex = content?.completed;
    
    if (index >= 0 || otherIndex === true) return true;
    return false;
  }

  function isMarkedAsWatched(lessons, content) {
    const index = lessons.findIndex(
      (item) => item.lesson_id === content.id && item.watched === true
    );
    if (index >= 0) return true;
    return false;
  }

  // function quizScrollHandler() {
  //     setTilebarItem("quiz")
  //     navigate(`/${course_slug']}/${content['skill_slug']}/${content['mskill_slug']}/${content['id']}`)
  //     const timeoutID = setTimeout(() => {
  //         quizRef.current.scrollIntoView()

  //         return () => {
  //             clearTimeout(timeoutID)
  //         }
  //     }, 500)
  // }
  function getStartEndTime(time) {
    let timeDuration;
    if (time > 3601) {
      timeDuration = new Date(time * 1000).toISOString().substr(11, 8);
    } else {
      timeDuration = new Date(time * 1000).toISOString().substr(11, 8).slice(3);
    }

    return timeDuration;
  }

  function getDuration(seconds) {
    // let time;
    if (seconds > 60) {
      if (seconds > 3600) {
        return `${(seconds / 3600).toFixed(1)} hours`;
      }
      return `${(seconds / 60).toFixed(0)} Min`;
    }
  }

  // console.log(content);
  return (
    <div className="relative my-1 flex flex-col items-start justify-center py-2">
      {/* <>1</> */}
      {!isTask ? (
        //    true ? (
        <div
          onClick={() =>
            navigate(
              user_token
                ? `/${content['course_slug']}/${content['skill_slug']}/${content['mskill_slug']}/${content['id']}`
                : `/${content['course_slug']}/${content['skill_slug']}/${content['mskill_slug']}/${content['id']}/new_user`
            )
          }
          className="flex w-full"
        >
          <div
            className={`relative flex h-12 w-full cursor-pointer flex-row items-center justify-between px-3 font-bold ${
              active ? 'text-cn_green' : ''
            }`}
            ref={active ? sidebarRef : null}
          >
            <div className="flex h-full w-[80%] items-center justify-start">
              <img
                src={content?.lesson_videoThumbnail}
                alt=""
                className="mr-4 h-12 w-16 rounded-lg object-cover"
              />
              <div>
                <h5 className="truncate-text text-sm">
                  {content['lesson-name']}
                </h5>
                <small className="text-xs font-light text-gray-400">
                  {getDuration(content?.video_duration)}
                </small>
                {/* {
                                content?.lesson_stop_time > 0 ?
                                    <div>
                                        <FontAwesomeIcon icon={faClock} className={`ml-5 mr-2 ${active ? "text-cn_green" : "text-gray-400"}`} size="sm" />
                                        <small className={`text-xs font-semibold ${active ? "text-cn_green" : "text-gray-400"}`}> {getStartEndTime(content?.lesson_start_time)} to {getStartEndTime(content?.lesson_stop_time === 0 ? content?.video_duration : content?.lesson_stop_time)}</small>
                                    </div> : null
                            } */}
              </div>
            </div>
            {
              content?.id === parseInt(contentId) ? (
                <img
                  urlEndpoint="https://assets.learntube.ai/files/"
                  src={
                    'https://assets.learntube.ai/files/Content_player/currentPlaying.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1657774438495'
                  }
                  className="h-7 w-7"
                  transformation={[
                    {
                      height: '60',
                      width: '60',
                    },
                  ]}
                />
              ) : isMarkedAsComplete(watchedLessons, content) ? (
                <div>
                  <img
                    urlEndpoint="https://assets.learntube.ai/files/"
                    src={
                      'https://assets.learntube.ai/files/Content_player/lessonCompleted.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1657774438589'
                    }
                    className="h-7 w-7"
                    transformation={[
                      {
                        height: '60',
                        width: '60',
                      },
                    ]}
                  />
                </div>
              ) : isMarkedAsWatched(watchedLessons, content) ? (
                <div className="text-gray-400">
                  <FontAwesomeIcon icon={faEye} size="xl" />
                </div>
              ) : (
                <div className="text-gray-400">
                  <FontAwesomeIcon icon={faPlayCircle} size="xl" />
                </div>
              )
              // <input type="checkbox" className="reactour-sidebar-watched" name="" id="" onClick={(e) => {
              //     e.stopPropagation()
              //     if (user_token !== undefined) {
              //         dispatch(markLessonAsWatched(userId, content['id'], successObj => {
              //             dispatch(addUserActivity(userId, userActivity.LESSON_WATCHED, "", false))
              //             setWatchedLessons(prev => [...prev, successObj])
              //         }))
              //     }
              //     else {
              //         navigate('/login', {
              //             state: {
              //                 from: {
              //                     pathname: `/${course_slug}/${skill_slug}/${mskill_slug}/${contentId}`,
              //                 },
              //             },
              //         })
              //     }

              // }} />
            }
          </div>
        </div>
      ) : (
          <div onClick={() => {
            // navigate(
            //   user_token
            //     ? `/${course_slug}/${skill_slug}/${task['mskill_slug']}/${contentId}`
            //     : `/${course_slug}/${skill_slug}/${task['mskill_slug']}/${contentId}/new_user`
            // );
            handleTaskChange()
            setTilebarItem("quiz")
          }} className={`${active && 'bg-gray-200'} flex justify-center items-center py-2 w-full`}>
          <TaskMskill taskSubmitted={task}  ></TaskMskill>
        </div>
      )}
      {/* <button className={`${isMarkedAsComplete(watchedLessons, content) ? 'bg-cn_green text-white' : "bg-white"} reactour-sidebar-quiz px-4 py-1 rounded text-xs font-semibold self-end mr-4`} disabled={content.completed} onClick={quizScrollHandler}>
                Quiz
            </button> */}
    </div>
  );
}
